export default __webpack_public_path__ + "e6be0c550fcd1dfd2f728c746e045879.png";